const IPV4_PATTERN =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

const HOSTNAME_PATTERN =
  /^(?=.{1,253}$)(?!-)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.(?!-)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;

const DOTTED_IPV4_LIKE_PATTERN = /^\d+\.\d+\.\d+\.\d+$/;

export function isValidPingTarget(value) {
  if (typeof value !== "string") {
    return false;
  }

  const target = value.trim();
  if (!target || /\s/.test(target)) {
    return false;
  }

  if (
    target.includes("://") ||
    /[/?#]/.test(target) ||
    target.includes("[") ||
    target.includes("]") ||
    target.includes("%")
  ) {
    return false;
  }

  if (IPV4_PATTERN.test(target)) {
    return true;
  }

  if (DOTTED_IPV4_LIKE_PATTERN.test(target) || target.includes(":")) {
    return false;
  }

  return HOSTNAME_PATTERN.test(target);
}
